import { useI18next } from "gatsby-plugin-react-i18next";
import React from "react";

interface HighlightFrameProps {
  highlights: string[];
}

const HighlightFrame: React.FC<HighlightFrameProps> = ({ highlights }) => {
  const { t } = useI18next();
  return (
    <div className="highlight-frame">
      <h2 className="highlight-frame__heading">{t("HIGHLIGHTS")}</h2>
      <div className="highlight-frame__frame">
        <ul className="list list--usps">
          {highlights.map((highlight, i) => (
            <li className="list__item" key={`highlight-${i}-${highlight}`}>
              {highlight}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HighlightFrame;
